var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_vm._v(_vm._s(_vm.$metaInfo.title))]),_c('div',{staticClass:"mt-3"},[_c('board-form',{attrs:{"submit-handler":_vm.createBoard}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }